export default {
  xs: '(max-width: 576px)',
  sm: '(min-width: 577px)', // can't be same pixel as xs, the style of xs is overwrite by this breakpoint by 1 pixel
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
  xl: '(min-width: 1200px)',
  xxl: '(min-width: 1400px)',
  xxxl: '(min-width: 2048px)',
};
